export enum Language {
  Pl = 'pl',
  En = 'en',
}
